import React from 'react';

import { Button, Form } from 'antd';

import { Header, Title } from '$app/shared/components/Header';
import { Container } from '$app/shared/components/Container';

export default function PriceFormPage(props) {
  const {
    history,
    title,
    onSubmit,
    isSubmitting,
    children,
  } = props;

  return (
    <Container>
      <Header className="justify">
        <Button type="link" onClick={() => history.goBack()}>
          <i className="fa fa-chevron-left fa-lg" aria-hidden="true" />
          <span className="panel-title" style={{ marginLeft: 3 }}>
            Back
          </span>
        </Button>
        <Title>{title}</Title>
      </Header>
      <div style={{ padding: 10 }}>
        <Form layout="vertical" onSubmit={onSubmit}>
          {children}
          <div>
            <Button type="primary" htmlType="submit" loading={isSubmitting}>
              <span> Save </span>
              <i className="fa fa-pencil fa-lg" aria-hidden="true" />
            </Button>
          </div>
        </Form>
      </div>
    </Container>
  );
}
